import * as React from 'react';
import * as ReactDOM from 'react-dom';
import {$} from "../util/$";
import {Questions} from "./Questions";


export function funnelGuide() {
    const element: HTMLElement = $('.js-funnel-guide') as HTMLElement;
    if (element === null) {
        return;
    }

    const data = JSON.parse(
        element.getAttribute('data-items') as string,
    );

    ReactDOM.render(
        <Questions data={data}/>,
        element,
    );
}
